import { ReportTemplateId } from 'pages/reporting/shared/reportTemplates'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_REPORT_ID = 'reportId'

export const enforceSiteIdSearchParam = z.object({
  [SEARCH_PARAM_ORG_ID]: z.string().optional(),
  [SEARCH_PARAM_SITE_ID]: z.string(),
})

export const reportingNewSearchParams = enforceSiteIdSearchParam

export type ReportingOrgSiteSearch = z.infer<typeof enforceSiteIdSearchParam>

export const createReportingOrgSiteSearch = ({
  orgId,
  siteId,
}: ReportingOrgSiteSearch): ReportingOrgSiteSearch => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
})

export const reportingReportSearchParams = z.object({
  ...enforceSiteIdSearchParam.shape,
  [SEARCH_PARAM_REPORT_ID]: z.string(),
  templateId: z.enum(ReportTemplateId).optional(),
  metadataEntryId: z.string().optional(),
  section: z.string().optional(),
})

export type ReportingReportSearch = z.infer<typeof reportingReportSearchParams>

export const createReportingReportSearch = ({
  orgId,
  reportId,
  siteId,
  templateId,
  metadataEntryId,
  section,
}: ReportingReportSearch): ReportingReportSearch => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_REPORT_ID]: reportId,
  [SEARCH_PARAM_SITE_ID]: siteId,
  templateId,
  metadataEntryId,
  section,
})
